import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { MdChat, MdSmartToy, MdClose } from 'react-icons/md';
import {
  Badge,
  Button,
  ClickAwayListener,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Stack,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup';

import
{
  apiHeader,
  BaseURL,
  formRegEx,
  formRegExReplacer,
  ReturnFormatedNumber,
} from '../../config/apiUrl';
import
{
  leadProgressColors,
  leadProgressOptions,
} from '../../constant/commonData';
import { Get, Patch, Post } from '../../Axios/AxiosFunctions';
import dayjs, { moment } from '../../utils/timeUtils';
import { setInterestsFilter } from '../../store/common/commonSlice';
import useDebounce from '../../CustomHooks/useDebounce';
import AddOrEditNotesModal from '../../modals/AddorEditNotesModal';
import NotesDetailPopup from '../../Component/NotesDetail';
import AddInterestModal from '../../modals/AddInterestModal';
import InterestsFilterModal from '../../modals/InterestsFilterModal';
import AreYouSureModal from '../../modals/AreYouSureModal';
import AssignDataRoomWithCalendarModal from '../../modals/AssignDataRoomWithCalendarModal';
import classes from './Interests.module.css';
import { FaHistory } from 'react-icons/fa';
import { AddTask, ContentCopy, Email, Sms } from '@mui/icons-material';
import AddTodoDialog from '../Conversation/dialogs/AddTodoDialog';
import AutoNotePanel from '../ContactsNew/components/AutoNotePanel';
import SendEmailDialog from '../ContactsNew/components/SendEmailDialog';
import SendSmsDialog from '../ContactsNew/components/SendSmsDialog';
import { formatPhoneNumber } from '../../utils/functions';
import { capitalizeWords } from '../../utils/functions';

/**
 * Interests component displays and manages a list of interests, including filtering, notes, pagination, and related modals.
 * Handles data fetching, updates, and user interactions for interests.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.title='Interests'] - The title of the page.
 * @param {string|null} [props.listingStatus=null] - The status of the listing.
 * @param {string|null} [props.entityId=null] - The entity ID.
 * @param {boolean} props.isShowAll - Whether to show all interests.
 * @param {string|null} [props.listingID=null] - The listing ID.
 * @param {string|null} [props.companyName=null] - The company name.
 */
const Interests = ( {
  title = 'Interests',
  listingStatus = null,
  entityId = null,
  isShowAll,
  listingID = null,
  companyName = null,
} ) =>
{
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    access_token: accessToken,
    user,
    company_id: companyId,
  } = useSelector( ( state ) => state?.authReducer );
  const { interestsFilter } = useSelector( ( state ) => state?.commonReducer );

  const isAdmin = ( user?.role || [] ).some( ( role ) =>
    [ 'admin', 'super-admin', 'executive', 'hr', 'sales' ].includes( role ),
  );
  const [ allAdmins, setAllAdmins ] = useState( [] );
  const [ listing, setListing ] = useState( [] );
  const [ loading, setLoading ] = useState( true );
  const [ page, setPage ] = useState( 1 );
  const [ rowsPerPage, setRowsPerPage ] = useState( 10 );
  const [ totalPages, setTotalPages ] = useState( 0 );
  const [allTriggers, setAllTriggers] = useState([]);
  const [allLeadProgressOptions, setAllLeadProgressOptions] = useState([]);

  // Lead Status
  const [ leadStatus, setLeadStatus ] = useState();

  // For Options
  const [ selectedItem, setSelectedItem ] = useState( null );

  const [ isModalOpen, setIsModalOpen ] = useState( '' );
  const [ isInterestModalOpen, setIsInterestModalOpen ] = useState( false );
  const [ contacts, setContacts ] = useState( [] );
  const [ isModalLoading, setIsModalLoading ] = useState( '' );
  const [ isDownloading, setIsDownloading ] = useState( false );

  // For Filter
  const [ allBrokers, setAllBrokers ] = useState( [] );

  const [ showFilterModal, setShowFilterModal ] = useState( false );

  const [ allListing, setAllListing ] = useState( [] );
  const [ inputListing, setInputListing ] = useState( '' );
  const listingDebouncedSearch = useDebounce( inputListing, 1000 );

  const [ search, setSearch ] = useState( interestsFilter?.search );
  const debouncedSearchTerm = useDebounce( search, 500 );

  const cleanSearchTerm = (term) => {
    if (!term) return '';
    const hasPhoneChars = /[\d\s\-\(\)]+/.test(term);
    const hasDigits = /\d/.test(term);
    if (hasDigits && hasPhoneChars && !term.includes('@')) {
      return term.replace(/[\s\-\(\)\.]/g, '');
    }
    return term;
  };

  const [ notesPopupAnchor, setNotesPopupAnchor ] = useState( null );
  const [ notes, setNotes ] = useState( [] );

  const [ isUpdating, setIsUpdating ] = useState( false );
  const [ statusPopupAnchor, setStatusPopupAnchor ] = useState( null );
  const open = Boolean( statusPopupAnchor );

  const [ historyPopupAnchor, setHistoryPopupAnchor ] = useState( null );
  const historyOpen = Boolean( historyPopupAnchor );

  const [ outsideLead, setOutsideLead ] = useState( false );

  const [ selectedInterest, setSelectedInterest ] = useState( '' );
  const [ selectedListingID, setSelectedListingID ] = useState( '' );
  // access data room modal
  const [ accessRoomModal, setAccessRoomModal ] = useState( false );
  const [ accessRoomLoader, setAccessRoomLoader ] = useState( false );
  const [ isAssignDataRoom, setIsAssignDataRoom ] = useState( '' );
  const [ isAssignAutoDataRoom, setIsAssignAutoDataRoom ] = useState( '' );
  const [ accessAutoRoomModal, setAccessAutoRoomModal ] = useState( false );
  const [ accessAutoRoomLoader, setAccessAutoRoomLoader ] = useState( false );
  const [ selectedNote, setSelectedNote ] = useState( null );

  const [ autoNotesPopupAnchor, setAutoNotesPopupAnchor ] = useState( null );
  const [ autoNoteItem, setAutoNoteItem ] = useState( null );
  const [ meetingSummaries, setMeetingSummaries ] = useState( [] );
  const [ phoneCallSummaries, setPhoneCallSummaries ] = useState( [] );

  const [ isTodoModalOpen, setIsTodoModalOpen ] = useState( null );

  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [smsDialogOpen, setSmsDialogOpen] = useState(false);
  const [emailContact, setEmailContact] = useState(null);
  const [smsContact, setSmsContact] = useState(null);

  const getAllTriggerEmails = async () => {
    const url = BaseURL(`trigger-email-template`);
    setLoading(true);
    const response = await Get(url, accessToken, companyId);
    setLoading(false);
    if (response?.data) {
      const data = response?.data || [];
      setAllLeadProgressOptions([...leadProgressOptions, ...data?.map(t => { return { label: capitalizeWords(t.title), value: t.title } })])
      setAllTriggers(data);
    }
  };

  /**
   * Returns the color for a given lead progress status.
   *
   * @param {string} status - The lead progress status.
   * @param {boolean} [isBackground=true] - Whether to return background or text color.
   * @returns {string}
   */
  const getLeadProgressColor = ( status, type = 'background' ) =>
  {
    const style = leadProgressColors[ status ] || leadProgressColors[ 'new' ];
    if ( type === 'color' ) return style.color;
    if ( type === 'border' ) return style.border || style.background;
    return style.background;
  };

  /**
   * Assigns or unassigns a buyer to a data room for a business.
   *
   * @async
   * @param {string} businessId - The business ID.
   * @param {boolean} isAssignDataRoom - Whether to assign or unassign.
   * @returns {Promise<void>}
   */
  const accessDataRoom = async ( businessId, isAssignDataRoom, date ) =>
  {
    const url = BaseURL(
      isAssignDataRoom
        ? `business/unassign-buyer-from-dataroom`
        : `business/assign-buyer-to-dataroom`,
    );
    const params = {
      businessId: businessId,
      ...( isAssignDataRoom
        ? { userId: selectedInterest?.buyer?._id }
        : { userIds: [ selectedInterest?.buyer?._id ], expireDate: date } ),
    };
    setAccessRoomLoader( true );
    const response = await Patch( url, params, apiHeader( accessToken ) );
    if ( response !== undefined )
    {
      toast.success( 'Assigned Successfully' );
      setIsAssignDataRoom( !isAssignDataRoom );

      let assigned = selectedInterest?.listingID?.buyerAssignedToDataRoom;
      if ( isAssignDataRoom )
      {
        assigned = assigned?.filter(
          ( ele ) => String( ele ) != String( selectedInterest?.buyer?._id ),
        );
      } else
      {
        assigned?.push( selectedInterest?.buyer?._id );
      }

      setListing(
        listing?.map( ( ele ) =>
        {
          if ( ele?._id == selectedInterest?._id )
          {
            return {
              ...selectedInterest,
              listingID: {
                ...ele?.listingID,
                buyerAssignedToDataRoom: assigned,
              },
            };
          } else
          {
            return ele;
          }
        } ),
      );
      setAccessRoomModal( false );
    }
    setAccessRoomLoader( false );
  };

  const accessAutoDataRoom = async ( businessId, isAssignAutoDataRoom, date ) =>
  {
    const url = BaseURL(
      isAssignAutoDataRoom
        ? `business/unassign-buyer-from-auto-dataroom`
        : `business/assign-buyer-to-auto-dataroom`,
    );
    const params = {
      businessId: businessId,
      ...( isAssignAutoDataRoom
        ? { userId: selectedInterest?.buyer?._id }
        : { userIds: [ selectedInterest?.buyer?._id ], expireDate: date } ),
    };
    setAccessAutoRoomLoader( true );
    const response = await Patch( url, params, apiHeader( accessToken ) );
    if ( response !== undefined )
    {
      toast.success( isAssignAutoDataRoom ? 'Unassigned Successfully' : 'Assigned Successfully' );
      setIsAssignAutoDataRoom( !isAssignAutoDataRoom );

      let assigned = selectedInterest?.listingID?.buyerAssignedToAutoDataRoom || [];
      if ( isAssignAutoDataRoom )
      {
        assigned = assigned?.filter(
          ( ele ) => String( ele ) != String( selectedInterest?.buyer?._id ),
        );
      } else
      {
        assigned = [ ...assigned, selectedInterest?.buyer?._id ];
      }

      setListing(
        listing?.map( ( ele ) =>
        {
          if ( ele?._id == selectedInterest?._id )
          {
            return {
              ...selectedInterest,
              listingID: {
                ...ele?.listingID,
                buyerAssignedToAutoDataRoom: assigned,
              },
            };
          } else
          {
            return ele;
          }
        } ),
      );
      setAccessAutoRoomModal( false );
    }
    setAccessAutoRoomLoader( false );
  };

  /**
   * Fetches all interests with optional filters and updates state.
   *
   * @async
   * @param {number} [pg=0] - The page number.
   * @param {string} [filterStatus] - The filter status.
   * @param {string} [lP] - The lead progress value.
   * @param {string} [br] - The broker ID.
   * @param {string} [com] - The company ID.
   * @returns {Promise<void>}
   */
  const getAllInterests = async (
    pg = 0,
    filterStatus = interestsFilter?.status?.value,
    lP = interestsFilter?.leadProgress?.value,
    br = interestsFilter?.broker?._id,
    com = listingID || interestsFilter?.company?._id,
  ) =>
  {
    const cleanedSearch = cleanSearchTerm(search);
    const url = BaseURL(
      `leads/admin?page=${pg}&limit=${rowsPerPage}&entity=${entityId}&status=${filterStatus}&lead-progress=${lP}&search=${cleanedSearch}&listing=${com}&broker=${br}&listing-status=${listingStatus}`,
    );
    setLoading( true );
    console.log( 'companyId', companyId );
    const response = await Get( url, accessToken, companyId );
    if ( response !== undefined )
    {
      console.log( 'interests => ', response?.data?.lead );
      setListing( response?.data?.lead );
      setLeadStatus(
        response?.data?.lead?.map( ( item ) =>
        {
          let status = leadProgressOptions?.find(
            ( e ) => e?.value == item?.leadProgress,
          );
          if (!status) {
            status = { label: capitalizeWords(item?.leadProgress), value: item?.leadProgress };
          }
          return {
            leadId: item?._id,
            status,
          };
        } ),
      );
      setTotalPages( response?.data?.countDoc );
    }
    setLoading( false );
  };

  const getNotes = () =>
  {
    if ( selectedItem )
    {
      Get( BaseURL( `notes/getNote/${selectedItem?.buyer?.email}?received=true` ), accessToken )
        .then( ( res ) =>
        {
          if ( Array.isArray( res?.data ) )
          {
            res?.data.sort( ( a, b ) => new Date( b?.date ) - new Date( a?.date ) );
            setNotes( res.data );
          }
        } )
        .catch( ( err ) =>
        {
          setNotes( [] );
        } );
    }
  };

  const getSummaries = async ( email ) =>
  {
    if ( !email ) return;
    try
    {
      const response = await Get( BaseURL( `leads/summaries-by-email?email=${email}` ), accessToken );
      setMeetingSummaries( response?.data?.meetingSummaries || [] );
      setPhoneCallSummaries( response?.data?.phoneCallSummaries || [] );
    } catch ( error )
    {
      setMeetingSummaries( [] );
      setPhoneCallSummaries( [] );
      console.error( 'Error fetching summaries:', error );
    }
  };

  const getAdmins = async () =>
  {
    const response = await Get(
      BaseURL(
        `users/get-admins?roles=${encodeURIComponent( [ 'super-admin', 'admin', 'broker', 'executive', 'hr', 'sales' ] )}`,
      ),
      accessToken,
      companyId,
      false,
    );
    if ( response )
    {
      setAllBrokers( response?.data?.data );
    }
  };

  /**
   * Fetches all buyer contacts matching the search string.
   *
   * @async
   * @param {string} search - The search string.
   * @returns {Promise<void>}
   */
  const getAllBuyerContacts = async ( search ) =>
  {
    if ( !search )
    {
      setContacts( [] );
      return;
    }
    const url = BaseURL( `users/buyers/all?search=${search}&page=0&limit=20` );
    const response = await Get( url, accessToken, companyId );
    if ( response !== undefined )
    {
      setContacts( response?.data?.data );
    }
  };

  /**
   * Updates the lead progress for a given lead.
   *
   * @async
   * @param {Object} lead - The lead object.
   * @param {Object} e - The event or selected option.
   * @returns {Promise<void>}
   */
  const updateLeadProgress = async ( lead, e ) =>
  {
    if ( !isAdmin && !lead?.listingID?.broker?.includes( user?._id ) )
    {
      return toast.error( 'You are not assigned to update this lead progress' );
    }
    const url = BaseURL( `leads/update-lead-status` );
    const body = {
      leadId: lead?._id,
      leadProgress: e?.value,
    };
    setIsUpdating( true );
    const response = await Patch( url, body, apiHeader( accessToken ) );
    setIsUpdating( false );
    if ( response?.data )
    {
      const newData = [ ...listing ];
      newData?.splice(
        newData.findIndex( ( item ) => item?._id == response?.data?._id ),
        1,
        response?.data,
      );
      setListing( newData );

      const newStatus = leadStatus?.map( ( item ) =>
        item?.leadId == response?.data?._id
          ? {
            ...item,
            status: e,
          }
          : item,
      );
      setLeadStatus( newStatus );
      toast.success( 'Lead progress updated successfully' );
      setStatusPopupAnchor( null );
      setSelectedItem( null );
    }
  };

  /**
   * Handles adding or updating a note for the selected item.
   *
   * @param {string} newNote - The note text.
   */
  const onSubmitNote = ( newNote ) =>
  {
    var postTime = new Date().toLocaleString();
    if ( !newNote || !selectedItem ) return;

    if ( !selectedNote )
    {
      Post( BaseURL( 'notes/create' ), {
        text: newNote,
        date: null,
        writer: `${user?.firstName} ${user?.lastName}`,
        sender: user?.email,
        receiver: selectedItem?.buyer?.email,
        listing: selectedItem?.listingID?._id,
      }, apiHeader(accessToken))
        .then( ( res ) =>
        {
          setNotes( [
            {
              text: newNote,
              date: postTime,
              writer: `${user?.firstName} ${user?.lastName}`,
              listing: selectedItem?.listingID,
              _id: res?.data?._id,
            },
            ...notes,
          ] );
          return toast.success( 'Added successfully.' );
        } )
        .catch( ( err ) =>
        {
          return toast.error( err.toString() );
        } );
    } else
    {
      Patch( BaseURL( `notes/${selectedNote?._id}` ), {
        text: newNote,
        date: postTime,
      }, apiHeader(accessToken))
        .then( () =>
        {
          setSelectedNote( null );
          const updatedNotes = notes?.map( ( note ) =>
          {
            if ( note?._id === selectedNote?._id )
            {
              note.text = newNote;
              note.date = postTime;
            }

            return note;
          } );
          setNotes( updatedNotes );
          return toast.success( 'Note updated successfully.' );
        } )
        .catch( ( err ) =>
        {
          return toast.error( err.toString() );
        } );
    }
  };

  /**
   * Handles adding notes to a lead via API call.
   *
   * @async
   * @param {string} body - The note body.
   * @returns {Promise<void>}
   */
  async function handleAddNotes( body )
  {
    setIsModalLoading( 'add-notes' );
    const url = BaseURL( 'leads/notes' );
    const response = await Patch(
      url,
      { leadId: selectedItem?._id, notes: body },
      apiHeader( accessToken ),
    );
    if ( response !== undefined && response?.data )
    {
      const index = listing?.findIndex(
        ( item ) => item?._id == selectedItem?._id,
      );
      const newData = [ ...listing ];
      newData?.splice( index, 1, response?.data );
      setListing( newData );
      setSelectedItem( response?.data );
      toast.success( 'Notes added successfully' );
    }
    setIsModalLoading( '' );
    setIsModalOpen( '' );
  }

  useEffect( () =>
  {
    if ( !inputListing )
    {
      setAllListing( [] );
      return;
    }
    Get(
      BaseURL( `business/admin/all?search=${inputListing}` ),
      accessToken,
      companyId,
    ).then( ( res ) =>
    {
      if ( Array.isArray( res?.data?.business ) )
      {
        console.log( res?.data?.business );
        setAllListing( res?.data?.business );
      } else
      {
        setAllListing( [] );
      }
    } );
  }, [ listingDebouncedSearch ] );

  useEffect(() => {
    getAllTriggerEmails();
  }, []);

  useEffect( () =>
  {
    getNotes();
  }, [ selectedItem ] );

  useEffect( () =>
  {
    getAllInterests( page );
  }, [ page, rowsPerPage ] );

  useEffect( () =>
  {
    dispatch( setInterestsFilter( { ...interestsFilter, search } ) );
    if ( page == 1 ) getAllInterests();
    setPage( 1 );
  }, [ debouncedSearchTerm ] );

  useEffect( () =>
  {
    Get( BaseURL( 'users/get-all-admins' ), accessToken, companyId, false ).then(
      ( allAdmins ) =>
      {
        setAllAdmins( allAdmins?.data?.data || [] );
      },
    );
  }, [] );

  /**
   * Handles downloading the interests list as an XLSX file.
   *
   * @async
   * @returns {Promise<void>}
   */
  const handleDownloadXlsx = async () =>
  {
    const filterStatus = interestsFilter?.status?.value;
    const br = interestsFilter?.broker?._id;
    const com = interestsFilter?.company?._id;
    const lP = interestsFilter?.leadProgress?.value;

    setIsDownloading( true );

    const url = BaseURL(
      `leads/admin/xlsx?entity=${entityId}&status=${filterStatus}&lead-progress=${lP}&search=${search}&listing=${com}&broker=${br}`,
    );

    const response = await Get(
      url,
      accessToken,
      companyId,
      true,
      undefined,
      'blob',
    );

    if ( response )
    {
      const blob = new Blob( [ response.data ], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      } );
      const fileURL = window.URL.createObjectURL( blob );
      const link = document.createElement( 'a' );
      link.href = fileURL;
      const fileName = `Interest_${dayjs()?.format( 'DD-MM-YYYY_hh-mm-ss_A' )}.xlsx`;
      link.setAttribute( 'download', fileName );
      document.body.appendChild( link );
      link.click();
      document.body.removeChild( link );
    }

    setIsDownloading( false );
  };

  useEffect( () =>
  {
    getAdmins();
  }, [] );

  /**
   * Handles adding a new interest via API call.
   *
   * @async
   * @param {Object} params - The parameters for the new interest.
   * @returns {Promise<void>}
   */
  const handleAddInterest = async ( params ) =>
  {
    for ( let key in params )
    {
      if (
        params[ key ] == '' ||
        params[ key ] == null ||
        params[ key ] == undefined
      )
      {
        return toast.error(
          `Please provide the ${key
            .replace( formRegEx, formRegExReplacer )
            .toLowerCase()}`,
        );
      }
    }
    setLoading( true );
    const data = {
      business: params?.listing?._id,
      contact: params?.contact?._id,
    };
    const response = await Post(
      BaseURL( `leads/add-interest` ),
      data,
      apiHeader( accessToken ),
      companyId,
    );
    console.log( 'response', response );
    if ( response !== undefined )
    {
      if ( page == 1 )
      {
        getAllInterests( 1 );
      } else
      {
        setPage( 1 );
      }
      toast.success( `Interest Created Successfully.` );
      setIsInterestModalOpen( false );
    }
    setLoading( false );
  };

  const getStatusRowColor = (status) => {
    switch (status) {
      case 'inquired':
        return '#F9FAFB';
      case 'nda-signed':
        return '#ECFDF5';
      case 'nda-submitted':
        return '#FFFBEB';
      case 'nda-approved':
        return '#EFF6FF';
      case 'nda-rejected':
        return '#FDF2F2';
      case 'VIP':
        return '#FFF1F2';
      default:
        return '#FFFFFF';
    }
  };

  const getStatusTextColor = (status) => {
    switch (status) {
      case 'inquired':
        return '#374151';
      case 'nda-signed':
        return '#166534';
      case 'nda-submitted':
        return '#92400E';
      case 'nda-approved':
        return '#3730A3';
      case 'nda-rejected':
        return '#991B1B';
      case 'VIP':
        return '#991B1B';
      default:
        return '#374151';
    }
  };

  const getStatusBorderColor = (status) => {
    switch (status) {
      case 'inquired':
        return '#D1D5DB';
      case 'nda-signed':
        return '#86EFAC';
      case 'nda-submitted':
        return '#FCD34D';
      case 'nda-approved':
        return '#A5B4FC';
      case 'nda-rejected':
        return '#FCA5A5';
      case 'VIP':
        return '#FCA5A5';
      default:
        return '#D1D5DB';
    }
  };

  const getStatusBgColor = (status) => {
    switch (status) {
      case 'inquired':
        return '#F3F4F6';
      case 'nda-signed':
        return '#DCFCE7';
      case 'nda-submitted':
        return '#FEF3C7';
      case 'nda-approved':
        return '#E0E7FF';
      case 'nda-rejected':
        return '#FEE2E2';
      case 'VIP':
        return '#FEE2E2';
      default:
        return '#F3F4F6';
    }
  };

  const copyToClipboard = (text, e) => {
    e?.stopPropagation();
    navigator.clipboard.writeText(text).then(() => {
      toast.success('Copied to clipboard', { autoClose: 1500 });
    });
  };

  return (
    <>
      {/* Header */}
      <Stack direction="row" justifyContent="space-between" alignItems="center" mt={2} px={2}>
        <Typography
          variant="h4"
          fontWeight={700}
          fontFamily="Bebas-Neue-bold"
          fontSize="35px"
          color="black"
        >
          INTERESTS
        </Typography>
        <Stack direction="row" spacing={1}>
          <Badge
            badgeContent={
              interestsFilter?.status?.value != 'all' ||
              interestsFilter?.leadProgress?.value != 'all' ||
              interestsFilter?.broker?._id != 'null' ||
              (interestsFilter?.company?._id && interestsFilter?.company?._id != listingID)
                ? ' '
                : 0
            }
            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
            sx={{
              '& .MuiBadge-badge': {
                minWidth: 15,
                height: 15,
                backgroundColor: '#ff0000',
              },
            }}
          >
            <Button
              variant="contained"
              sx={{ textTransform: 'capitalize' }}
              onClick={() => setShowFilterModal(true)}
            >
              Filter Interests
            </Button>
          </Badge>
          <Button
            variant="contained"
            sx={{ textTransform: 'capitalize' }}
            onClick={() => setIsInterestModalOpen(true)}
          >
            Add interest
          </Button>
          <Button
            variant="contained"
            sx={{ textTransform: 'capitalize' }}
            onClick={() => handleDownloadXlsx()}
            disabled={isDownloading}
          >
            {isDownloading ? 'Downloading...' : 'Download'}
          </Button>
        </Stack>
      </Stack>

      {/* Search */}
      <Box px={2} mb={2} mt={1}>
        <TextField
          size="small"
          placeholder="Type here to search..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          fullWidth
          sx={{
            bgcolor: '#FFFFFF',
            borderRadius: '12px',
            boxShadow: '0 1px 0 rgba(0,0,0,.02)',
            '& .MuiOutlinedInput-root': {
              borderRadius: '12px',
              '& fieldset': { borderColor: '#E5E7EB' },
              '&:hover fieldset': { borderColor: '#D1D5DB' },
            },
            '& .MuiInputBase-input::placeholder': { color: '#94A3B8' },
          }}
        />
      </Box>

      {/* Table */}
      <Box px={2}>
        <TableContainer component={Paper} sx={{ maxHeight: isShowAll ? 'none' : 'calc(100vh - 330px)', border: '1px solid #E5E7EB', borderRadius: '16px', boxShadow: '0 12px 30px rgba(15, 76, 129, .08)' }}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 600, color: 'white', bgcolor: 'primary.main', minWidth: 120, textAlign: 'center' }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 600, color: 'white', bgcolor: 'primary.main', minWidth: 200, textAlign: 'center' }}>Listing</TableCell>
                {!outsideLead && (
                  <TableCell sx={{ fontWeight: 600, color: 'white', bgcolor: 'primary.main', minWidth: 180, textAlign: 'center' }}>Email</TableCell>
                )}
                <TableCell sx={{ fontWeight: 600, color: 'white', bgcolor: 'primary.main', minWidth: 240, textAlign: 'center' }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: 600, color: 'white', bgcolor: 'primary.main', minWidth: 180, textAlign: 'center' }}>Lead Progress</TableCell>
                <TableCell sx={{ fontWeight: 600, color: 'white', bgcolor: 'primary.main', minWidth: 140, textAlign: 'center' }}>Status</TableCell>
                <TableCell sx={{ fontWeight: 600, color: 'white', bgcolor: 'primary.main', minWidth: 120, textAlign: 'center' }}>Deal Room</TableCell>
                <TableCell sx={{ fontWeight: 600, color: 'white', bgcolor: 'primary.main', minWidth: 140, textAlign: 'center' }}>Auto Deal Room</TableCell>
                <TableCell sx={{ fontWeight: 600, color: 'white', bgcolor: 'primary.main', minWidth: 120, textAlign: 'center' }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading && (!listing || listing.length === 0) ? (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                    Loading interests...
                  </TableCell>
                </TableRow>
              ) : !listing || listing.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                    No interests found
                  </TableCell>
                </TableRow>
              ) : (
                listing?.map((item, index) => (
                  <TableRow
                    key={item._id || index}
                    sx={{
                      cursor: 'pointer',
                      backgroundColor: getStatusRowColor(item?.status),
                      '&:hover': { backgroundColor: '#F1F5F9' },
                    }}
                  >
                    <TableCell align="center">
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
                        {item?.outsideLead ? (
                          <Typography variant="body2">{item?.contactName}</Typography>
                        ) : (
                          <Link
                            to={`/view-interest/${item?._id}`}
                            style={{ textTransform: 'capitalize', color: 'inherit', textDecoration: 'none' }}
                          >
                            <Typography variant="body2" sx={{ '&:hover': { color: 'primary.main' } }}>
                              {`${item?.buyer?.firstName} ${item?.buyer?.lastName}`}
                            </Typography>
                          </Link>
                        )}
                        <Tooltip title="Copy">
                          <IconButton
                            size="small"
                            onClick={(e) => copyToClipboard(`Contact: ${item?.outsideLead ? item?.contactName : `${item?.buyer?.firstName} ${item?.buyer?.lastName}`}\nEmail: ${item?.buyer?.email}\nPhone: ${formatPhoneNumber(item?.contactPhone) || item?.contactPhone}`, e)}
                          >
                            <ContentCopy fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                    <TableCell align="center">
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
                        <Tooltip title={item?.listingID?.companyName || ''}>
                          <Link
                            to={`/listing-detail/${item?.listingID?.slug}?company-name=${encodeURIComponent(item?.listingID?.companyName)}&id=${item?.listingID?._id}&status=${item?.listingID?.status}`}
                            style={{ textTransform: 'capitalize', color: 'inherit', textDecoration: 'none' }}
                          >
                            <Typography variant="body2" sx={{ '&:hover': { color: 'primary.main' } }}>
                              {item?.listingID?.companyName}
                            </Typography>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Copy">
                          <IconButton
                            size="small"
                            onClick={(e) => copyToClipboard(item?.listingID?.companyName, e)}
                          >
                            <ContentCopy fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                    {!item?.outsideLead && (
                      <TableCell align="center">
                        <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
                          <Link
                            to={`/contacts-new`}
                            state={{ email: item?.buyer?.email }}
                            title={item?.buyer?.email}
                            style={{ color: 'inherit', textDecoration: 'none' }}
                          >
                            <Typography
                              variant="body2"
                              sx={{
                                maxWidth: 180,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                '&:hover': { color: 'primary.main' },
                              }}
                            >
                              {item?.buyer?.email}
                            </Typography>
                          </Link>
                          <Tooltip title="Send email">
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setEmailContact(item?.buyer);
                                setEmailDialogOpen(true);
                              }}
                            >
                              <Email fontSize="small" />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Copy">
                            <IconButton
                              size="small"
                              onClick={(e) => copyToClipboard(item?.buyer?.email, e)}
                            >
                              <ContentCopy fontSize="small" />
                            </IconButton>
                          </Tooltip>
                        </Stack>
                      </TableCell>
                    )}
                    <TableCell align="center">
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={0.5}>
                        <a href={`tel:${item?.contactPhone}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                          <Typography variant="body2">
                            {!outsideLead ? ReturnFormatedNumber(item?.contactPhone) : item?.contactPhone}
                          </Typography>
                        </a>
                        <Tooltip title="Send text">
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation();
                              const nameParts =
                                item?.contactName?.trim().split(/\s+/) || [];
                              setSmsContact({
                                ...(item?.buyer || {}),
                                contact:
                                  item?.contactPhone || item?.buyer?.contact,
                                firstName: item?.outsideLead
                                  ? nameParts[0] || ''
                                  : item?.buyer?.firstName,
                                lastName: item?.outsideLead
                                  ? nameParts.slice(1).join(' ')
                                  : item?.buyer?.lastName,
                              });
                              setSmsDialogOpen(true);
                            }}
                          >
                            <Sms fontSize="small" />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Copy">
                          <IconButton
                            size="small"
                            onClick={(e) => copyToClipboard(item?.contactPhone, e)}
                          >
                            <ContentCopy fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                    <TableCell align="center">
                      <Stack direction="row" justifyContent="center" alignItems="center" spacing={1}>
                        <Box
                          className={classes.progressSpan}
                          sx={{
                            backgroundColor: getLeadProgressColor(leadStatus?.[index]?.status?.value),
                            color: getLeadProgressColor(leadStatus?.[index]?.status?.value, 'color'),
                            padding: '6px 10px',
                            borderRadius: '999px',
                            cursor: 'pointer',
                            textAlign: 'center',
                            fontSize: '12px',
                            border: `1px solid ${getLeadProgressColor(leadStatus?.[index]?.status?.value, 'border')}`,
                            ...(open && selectedItem?._id == item?._id && {
                              border: 'solid 2px rgb(255, 0, 0)',
                            }),
                          }}
                          onClick={(event) => {
                            event.stopPropagation();
                            setSelectedItem(item);
                            setStatusPopupAnchor(statusPopupAnchor ? null : event.currentTarget);
                          }}
                        >
                          <div>{leadStatus?.[index]?.status?.value?.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join('-')}</div>
                          <div style={{ fontSize: '10px' }}>
                            {moment(item?.progressUpdatedAt || item?.createdAt).format('MM/DD/YY hh:mm')}
                          </div>
                        </Box>
                        <Tooltip title="View History">
                          <IconButton
                            size="small"
                            sx={{ color: '#2563EB', width: 32, height: 32, borderRadius: '10px', border: '1px solid #E5E7EB', bgcolor: '#fff', '&:hover': { bgcolor: '#F1F5F9', borderColor: '#E2E8F0' } }}
                            onClick={(event) => {
                              event.stopPropagation();
                              if (!item?.leadProgressHistory || !item?.leadProgressHistory?.length) return;
                              setSelectedItem(item);
                              setHistoryPopupAnchor(historyPopupAnchor ? null : event.currentTarget);
                            }}
                          >
                            <FaHistory />
                          </IconButton>
                        </Tooltip>
                      </Stack>
                    </TableCell>
                    <TableCell align="center">
                      <Box
                        sx={{
                          display: 'inline-block',
                          padding: '6px 10px',
                          borderRadius: '999px',
                          whiteSpace: 'pre-wrap',
                          backgroundColor: getStatusBgColor(item?.status),
                          color: getStatusTextColor(item?.status),
                          border: `1px solid ${getStatusBorderColor(item?.status)}`,
                          fontSize: '12px',
                        }}
                      >
                        {item?.status === 'inquired' ? 'Inquired'
                          : item?.status === 'nda-submitted' ? 'Nda-Submitted'
                          : item?.status === 'nda-signed' ? 'Nda-Signed'
                          : item?.status === 'nda-approved' ? 'Nda-Approved'
                          : item?.status === 'nda-rejected' ? 'Nda-Rejected'
                          : item?.status}
                        {'\n('}
                        {moment(item?.statusUpdatedAt || item?.createdAt).format('MM/DD/YY hh:mm')}
                        {')'}
                      </Box>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ width: '98px', px: 0, textTransform: 'capitalize' }}
                        onClick={() => {
                          const query =
                            item?.listingID?.buyerAssignedToDataRoom?.includes(
                              item?.buyer?._id,
                            );
                          setSelectedInterest(item);
                          setSelectedListingID(item?.listingID?._id);
                          setIsAssignDataRoom(query);
                          setAccessRoomModal(true);
                        }}
                        disabled={
                          !isAdmin &&
                          !item?.listingID?.broker?.includes(user?._id)
                        }
                      >
                        {item?.listingID?.buyerAssignedToDataRoom?.includes(
                          item?.buyer?._id,
                        )
                          ? 'Unassign'
                          : 'Assign'}
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        variant="contained"
                        size="small"
                        sx={{ width: '98px', px: 0, textTransform: 'capitalize' }}
                        onClick={() => {
                          const query =
                            item?.listingID?.buyerAssignedToAutoDataRoom?.includes(
                              item?.buyer?._id,
                            );
                          setSelectedInterest(item);
                          setSelectedListingID(item?.listingID?._id);
                          setIsAssignAutoDataRoom(query);
                          setAccessAutoRoomModal(true);
                        }}
                        disabled={
                          (!isAdmin &&
                          !item?.listingID?.broker?.includes(user?._id)) ||
                          item?.listingID?.storageType != 'sharepoint'
                        }
                      >
                        {item?.listingID?.buyerAssignedToAutoDataRoom?.includes(
                          item?.buyer?._id,
                        )
                          ? 'Unassign'
                          : 'Assign'}
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Stack direction="row" spacing={0.5} justifyContent="center" alignItems="center">
                        <Tooltip title="Notes">
                          <IconButton
                            size="small"
                            sx={{ color: selectedItem?._id == item?._id && notesPopupAnchor ? '#ED6C02' : '#2563EB', width: 32, height: 32, borderRadius: '10px', border: '1px solid #E5E7EB', bgcolor: '#fff', '&:hover': { bgcolor: '#F1F5F9', borderColor: '#E2E8F0' } }}
                            onClick={(event) => {
                              event.stopPropagation();
                              notesPopupAnchor && setNotes([]);
                              setSelectedItem(notesPopupAnchor ? null : item);
                              setNotesPopupAnchor(notesPopupAnchor ? null : event.currentTarget);
                            }}
                          >
                            <MdChat size={16}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Auto Note">
                          <IconButton
                            size="small"
                            sx={{ color: autoNoteItem?._id == item?._id && autoNotesPopupAnchor ? '#ED6C02' : '#2563EB', width: 32, height: 32, borderRadius: '10px', border: '1px solid #E5E7EB', bgcolor: '#fff', '&:hover': { bgcolor: '#F1F5F9', borderColor: '#E2E8F0' } }}
                            onClick={(event) => {
                              event.stopPropagation();
                              if (autoNotesPopupAnchor) {
                                setAutoNotesPopupAnchor(null);
                                setAutoNoteItem(null);
                                setMeetingSummaries([]);
                                setPhoneCallSummaries([]);
                              } else {
                                setAutoNoteItem(item);
                                setAutoNotesPopupAnchor(event.currentTarget);
                                getSummaries(item?.buyer?.email);
                              }
                            }}
                          >
                            <MdSmartToy size={16}/>
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Create Task">
                          <IconButton
                            size="small"
                            sx={{ color: '#2563EB', width: 32, height: 32, borderRadius: '10px', border: '1px solid #E5E7EB', bgcolor: '#fff', '&:hover': { bgcolor: '#F1F5F9', borderColor: '#E2E8F0' } }}
                            onClick={(event) => {
                              event.stopPropagation();
                              setIsTodoModalOpen(item);
                            }}
                          >
                            <AddTask sx={{ fontSize: 16 }} />
                          </IconButton>
                        </Tooltip>
                        {/* {!isAdmin && (
                          <Tooltip title="Messages">
                            <IconButton
                              size="small"
                              color="primary"
                              onClick={(event) => {
                                event.stopPropagation();
                                navigate(`/messages`, { state: item?.room });
                              }}
                            >
                              <BsChatDots />
                            </IconButton>
                          </Tooltip>
                        )} */}
                      </Stack>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination Footer */}
        {(() => {
          const totalPageCount = Math.ceil(totalPages / rowsPerPage);
          const startItem = totalPages === 0 ? 0 : (page - 1) * rowsPerPage + 1;
          const endItem = Math.min(page * rowsPerPage, totalPages);

          // Build visible page numbers (max 3 around current)
          const getPageNumbers = () => {
            const pages = [];
            let start = Math.max(1, page - 1);
            let end = Math.min(totalPageCount, start + 2);
            if (end - start < 2) start = Math.max(1, end - 2);
            for (let i = start; i <= end; i++) pages.push(i);
            return pages;
          };

          const btnBase = {
            width: 34,
            height: 34,
            borderRadius: '10px',
            border: '1px solid #E5E7EB',
            bgcolor: '#fff',
            color: '#1F2937',
            fontWeight: 900,
            fontSize: 14,
            minWidth: 34,
            p: 0,
            cursor: 'pointer',
            '&:hover': { bgcolor: '#F1F5F9' },
          };
          const btnActive = {
            ...btnBase,
            bgcolor: '#2563EB',
            color: '#fff',
            borderColor: '#2563EB',
            '&:hover': { bgcolor: '#1D4ED8' },
          };
          const btnDisabled = {
            ...btnBase,
            color: '#D1D5DB',
            cursor: 'default',
            '&:hover': { bgcolor: '#fff' },
          };

          return (
            <Paper sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: '14px', px: '14px', py: '12px' }}>
              <Typography sx={{ color: '#6B7280', fontWeight: 700, fontSize: 13 }}>
                Rows per page: <strong style={{ color: '#1F2937' }}>{rowsPerPage}</strong>
                &nbsp;&nbsp;&middot;&nbsp;&nbsp;
                <strong style={{ color: '#1F2937' }}>{startItem}–{endItem}</strong> of <strong style={{ color: '#1F2937' }}>{totalPages}</strong>
              </Typography>
              <Stack direction="row" spacing={0.75}>
                <Box
                  component="button"
                  onClick={() => page > 1 && setPage(page - 1)}
                  sx={page <= 1 ? btnDisabled : btnBase}
                >
                  ‹
                </Box>
                {getPageNumbers().map((p) => (
                  <Box
                    key={p}
                    component="button"
                    onClick={() => setPage(p)}
                    sx={p === page ? btnActive : btnBase}
                  >
                    {p}
                  </Box>
                ))}
                <Box
                  component="button"
                  onClick={() => page < totalPageCount && setPage(page + 1)}
                  sx={page >= totalPageCount ? btnDisabled : btnBase}
                >
                  ›
                </Box>
              </Stack>
            </Paper>
          );
        })()}
      </Box>

      {/* Popups */}
      {open && (
        <ClickAwayListener onClickAway={() => setStatusPopupAnchor(null)}>
          <BasePopup
            open={open}
            anchor={statusPopupAnchor}
            placement="left"
            style={{ zIndex: 1300 }}
          >
            <div
              style={{
                display: 'flex',
                width: '315px',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '20px 15px',
                height: '500px',
                overflowY: 'auto',
                border: 'solid 1px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                borderRadius: '15px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                ...(isUpdating && {
                  backgroundColor: '#e5e5e5',
                  cursor: 'not-allowed',
                }),
              }}
            >
              {allLeadProgressOptions?.map((item, index) => (
                <div
                  onClick={() =>
                    !isUpdating &&
                    item?.value != selectedItem?.leadProgress &&
                    updateLeadProgress(selectedItem, item)
                  }
                  key={index}
                  className={classes.progressItems}
                  style={{
                    cursor: 'pointer',
                    ...(isUpdating && { cursor: 'not-allowed' }),
                    padding: '10px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: 'solid 1px rgba(0, 0, 0, 0.1)',
                    ...(item?.value == selectedItem?.leadProgress && {
                      borderBottom: 'none',
                      backgroundColor: 'gray',
                      color: 'white',
                    }),
                  }}
                >
                  {item?.label}
                  <span style={{ display: 'inline-block', marginLeft: '10px' }}>
                    {selectedItem?.leadProgressHistory?.find(
                      (ele) => ele?.leadProgress == item?.value,
                    )?.date
                      ? moment(
                          selectedItem?.leadProgressHistory?.find(
                            (ele) => ele?.leadProgress == item?.value,
                          )?.date,
                        ).format('MM/DD/YY hh:mm')
                      : ''}
                  </span>
                </div>
              ))}
            </div>
          </BasePopup>
        </ClickAwayListener>
      )}

      {historyOpen && (
        <ClickAwayListener onClickAway={() => setHistoryPopupAnchor(null)}>
          <BasePopup
            open={historyOpen}
            anchor={historyPopupAnchor}
            placement="right"
            style={{ zIndex: 1300 }}
          >
            <div
              style={{
                display: 'flex',
                width: '315px',
                flexDirection: 'column',
                alignItems: 'center',
                padding: '20px 15px',
                maxHeight: '500px',
                overflowY: 'auto',
                border: 'solid 1px rgba(0, 0, 0, 0.1)',
                backgroundColor: '#fff',
                borderRadius: '15px',
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
                ...(isUpdating && {
                  backgroundColor: '#e5e5e5',
                  cursor: 'not-allowed',
                }),
              }}
            >
              {selectedItem?.leadProgressHistory?.map((item, index) => (
                <div
                  key={index}
                  className={classes.progressItems}
                  style={{
                    cursor: 'pointer',
                    ...(isUpdating && { cursor: 'not-allowed' }),
                    padding: '10px',
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'space-between',
                    borderBottom: 'solid 1px rgba(0, 0, 0, 0.1)',
                    textTransform: 'capitalize',
                  }}
                >
                  {item?.leadProgress}
                  <span style={{ display: 'inline-block', marginLeft: '10px' }}>
                    {moment(item?.date).format('MM/DD/YY hh:mm')}
                  </span>
                </div>
              ))}
            </div>
          </BasePopup>
        </ClickAwayListener>
      )}

      <NotesDetailPopup
        anchor={notesPopupAnchor}
        notes={notes}
        userId={selectedItem?.buyer?._id}
        meetingSummaries={[]}
        phoneCallSummaries={[]}
        onAdd={(message) => {
          onSubmitNote(message);
        }}
        onClose={() => {
          setNotes([]);
          setSelectedItem(null);
          setNotesPopupAnchor(null);
        }}
        onEdit={(note) => {
          setSelectedNote(note);
        }}
        selectedNote={selectedNote}
        isInterestsPage={true}
      />

      {/* Auto Notes Popup */}
      {Boolean(autoNotesPopupAnchor) && (
        <ClickAwayListener onClickAway={() => {
          setAutoNotesPopupAnchor(null);
          setAutoNoteItem(null);
          setMeetingSummaries([]);
          setPhoneCallSummaries([]);
        }}>
          <BasePopup
            open={Boolean(autoNotesPopupAnchor)}
            anchor={autoNotesPopupAnchor}
            placement="left"
            style={{ zIndex: 1300 }}
          >
            <Paper
              sx={{
                width: 500,
                maxHeight: 600,
                overflow: 'auto',
                p: 2,
                borderRadius: 2,
                boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
              }}
            >
              <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                <Typography variant="h6" fontWeight={600}>
                  Auto Notes
                </Typography>
                <IconButton
                  size="small"
                  onClick={() => {
                    setAutoNotesPopupAnchor(null);
                    setAutoNoteItem(null);
                    setMeetingSummaries([]);
                    setPhoneCallSummaries([]);
                  }}
                >
                  <MdClose />
                </IconButton>
              </Stack>
              <AutoNotePanel
                meetingSummaries={meetingSummaries}
                phoneCallSummaries={phoneCallSummaries}
                isInterestsPage={true}
              />
            </Paper>
          </BasePopup>
        </ClickAwayListener>
      )}

      {isModalOpen == 'add-notes' && (
        <AddOrEditNotesModal
          setShow={() => setIsModalOpen( '' )}
          show={isModalOpen == 'add-notes'}
          selectedUser={selectedItem}
          loading={isModalLoading == 'add-notes'}
          onClick={handleAddNotes}
        />
      )}
      <AddInterestModal
        show={isInterestModalOpen}
        setShow={setIsInterestModalOpen}
        selectedListing={{ _id: listingID, companyName: companyName }}
        listings={allListing}
        inputListing={inputListing}
        setInputListing={setInputListing}
        contacts={contacts}
        getContacts={getAllBuyerContacts}
        handleSubmit={handleAddInterest}
        isLoading={loading}
      />
      {showFilterModal && (
        <InterestsFilterModal
          isAdmin={isAdmin}
          show={showFilterModal}
          setShow={setShowFilterModal}
          status={interestsFilter?.status}
          allTriggers={allTriggers}
          leadProgress={interestsFilter?.leadProgress}
          broker={interestsFilter?.broker}
          allBrokers={allBrokers}
          allListing={allListing}
          listing={interestsFilter?.company}
          inheritListing={{ _id: listingID, companyName }}
          inputListing={inputListing}
          setInputListing={setInputListing}
          setFilter={( status, leadProgress, broker, listing ) =>
          {
            setShowFilterModal( false );

            dispatch(
              setInterestsFilter( {
                ...interestsFilter,
                company: {
                  _id: listing?._id,
                  companyName: listing?.companyName,
                },
                status,
                ...( listingID ? {} : { leadProgress } ),
                broker,
              } ),
            );

            if ( page == 1 )
              getAllInterests(
                1,
                status?.value,
                leadProgress?.value,
                broker?._id,
                listing?._id ? listing?._id : 'null',
              );
            else setPage( 1 );
          }}
        />
      )}
      {accessRoomModal && (
        isAssignDataRoom ? (
          <AreYouSureModal
            show={accessRoomModal}
            setShow={setAccessRoomModal}
            subTitle={'Unassign Room'}
            isApiCall={accessRoomLoader}
            onClick={() => accessDataRoom( selectedListingID, isAssignDataRoom )}
          />
        ) : (
          <AssignDataRoomWithCalendarModal
            show={accessRoomModal}
            setShow={setAccessRoomModal}
            subTitle={'Assign Room'}
            isApiCall={accessRoomLoader}
            onClick={( date ) => accessDataRoom( selectedListingID, isAssignDataRoom, date )}
          />
        )
      )}
      {accessAutoRoomModal && (
        isAssignAutoDataRoom ? (
          <AreYouSureModal
            show={accessAutoRoomModal}
            setShow={setAccessAutoRoomModal}
            subTitle={'Unassign Auto Room'}
            isApiCall={accessAutoRoomLoader}
            onClick={() => accessAutoDataRoom( selectedListingID, isAssignAutoDataRoom )}
          />
        ) : (
          <AssignDataRoomWithCalendarModal
            show={accessAutoRoomModal}
            setShow={setAccessAutoRoomModal}
            subTitle={'Assign Auto Room'}
            isApiCall={accessAutoRoomLoader}
            onClick={( date ) => accessAutoDataRoom( selectedListingID, isAssignAutoDataRoom, date )}
          />
        )
      )}

      <SendEmailDialog
        open={emailDialogOpen}
        onClose={() => {
          setEmailDialogOpen(false);
          setEmailContact(null);
        }}
        contact={emailContact}
      />

      <SendSmsDialog
        open={smsDialogOpen}
        onClose={() => {
          setSmsDialogOpen(false);
          setSmsContact(null);
        }}
        contact={smsContact}
      />

      {isTodoModalOpen && (
        <AddTodoDialog
          open={isTodoModalOpen}
          setOpen={setIsTodoModalOpen}
          allAdmins={allAdmins}
          preDescription={`Business: ${isTodoModalOpen?.listingID?.companyName}\n\nBuyer: ${isTodoModalOpen?.buyer?.firstName} ${isTodoModalOpen?.buyer?.lastName}\nEmail: ${isTodoModalOpen?.buyer?.email}\nPhone: ${formatPhoneNumber( isTodoModalOpen?.buyer?.contact )}\n`}
          onSuccess={() => setIsTodoModalOpen( null )}
        />
      )}
    </>
  );
};

export default Interests;
